<template>
  <div class="atividades-sacsolicitacoes ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="5">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <!-- condicional para exibir o botão planilha-->
        <b-col cols="2">
          <br />
          <input type="file" @change="handleFileUpload" />
        </b-col>

        <b-col cols="2">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            block
            @click="(carregando = true), postFuncoes()"
          >
            Gravar
          </b-button>
        </b-col>

        <b-col cols="3" class="mb-0">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Registro ou Tipo de solicitação ou palavras na solicitação"
          ></b-form-input>
        </b-col>
        <LoadingModal v-if="isLoadingFuncao" />
      </b-row>
    </b-form>

    <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>
      <b-card
        class="ml-2"
        style="width: 33rem"
        border-variant="primary"
        header="QUANTIDADE DE FUNÇÕES"
        header-bg-variant="primary"
        header-text-variant="white"
        align="center"
      >
        <b-card-text>
          <h2>
            {{ planilhaFuncao ? planilhaFuncao.length : 0 }}
          </h2>
        </b-card-text>
      </b-card>
    </b-card-group>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>

    <b-progress max="100" :value="progressValue">
      <template v-slot:label>{{ progressValue.toFixed(2) }}%</template>
    </b-progress>

    <!--tbl de dados -->
    <b-table
      id="resolicitante"
      small
      hover
      striped
      sticky-header="756px"
      :items="itemsFiltered"
      :fields="fieldsRecibos"
    >
    </b-table>

    <!--  MODAL SOLICITÇÕES  -->
    <div>
      <b-modal
        id="modal-multi-1"
        cancel-title="Fechar"
        ok-title="Gravar"
        @ok="postFuncao()"
        size="xl"
        :title="`Solicitação Nº.: ${
          sacsolicitacao.id_solicitacao != null
            ? sacsolicitacao.id_solicitacao
            : '-'
        }`"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- -->
        <div>
          <b-row>
            <input
              id="id-sac"
              type="hidden"
              v-model="sacsolicitacao.id_solicitacao"
            />

            <b-col cols="1" class="mt-2 pr-4">
              <b-form-group label="" label-for="tabela-foto">
                <b-img
                  height="120"
                  width="78"
                  class="mb-5"
                  v-model="sacsolicitacao.foto_url"
                  v-bind="mainProps"
                  rounded
                  alt="Foto"
                  :src="sacsolicitacao.foto_url"
                >
                </b-img>
              </b-form-group>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Registro</label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.re_solicitante"
                readonly
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Nome</label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.nome"
                readonly
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Função</label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.funcao_solicitante"
                readonly
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col sm="3" class="mt-5">
              <label for="input-resolicitante">Parecer</label>
              <div>
                <b-form-select
                  id="resolicitante"
                  v-model="sacsolicitacao.id_status"
                  :options="statuss"
                  class="mb-3"
                  text-field="status"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <label for="textarea-small">Justificativa</label>
            </b-col>
            <b-col sm="12">
              <b-form-textarea
                id="id-pecas"
                v-model="sacsolicitacao.justificativa"
                readonly
                size="sm"
                class="mb-3"
                placeholder="Pergunta do colaborador"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <!-- Tratativas -->
          <div class="d-flex justify-content-center mb-3">
            <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
          </div>
          <!--tbl de dados -->

          <b-row>
            <b-col sm="12">
              <label for="textarea-small">Parecer da solicitação:</label>
            </b-col>
            <b-col sm="12">
              <b-form-textarea
                id="id-obs"
                v-model="sacsolicitacao.parecer"
                size="sm"
                placeholder="Digite o parecer para o colaborador"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="mb-3 mt-3 ml-5">
              <div>
                <b-img
                  v-if="sacsolicitacao.file === 'true'"
                  :src="sacsolicitacao.file"
                  width="600"
                  height="600"
                ></b-img>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import * as XLSX from "xlsx";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "SacSolicitacao",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valores = [];

      valores = this.planilhaFuncao.filter((item) => {
        // Verifica se item.FUNCAO existe e é uma string
        const cod = item.FUNCAO ? String(item.FUNCAO) : ""; // Se FUNCAO for undefined ou null, converte para string vazia

        // Converte tanto o valor de busca quanto o valor de FUNCAO para minúsculas
        return cod.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });

      return valores;
    },
  },

  data: function () {
    return {
      planilhaFuncao: [],
      funcao: {},
      isLoadingFuncao: false, // Controle de carregamento
      progressValue: 0, // Valor da barra de progresso
      mode: "save",
      carregando: false,
      atualizando: false,
      empresa: {},
      empresas: [], // [] lista
      value_empresa: [], // [this.empresas],
      value_filial: [],
      value_status: [],
      filial: {},
      filiais: [], // [] lista
      //value_filial:[],// [] lista

      status: {},
      statuss: [], // [] lista

      permissoes: [],
      permissao: {},

      sacsolicitacao: {}, // [] lista
      sacsolicitacoes: [], // [] lista
      pedidoferias: [], // implantado 08/07/2023
      sacT: {}, // [] lista
      sacsolicitacoestratativa: [], // [] lista
      search: "",

      value_id_area: "",

      fieldsRecibos: [
        { key: "FUNCAO", label: "Função", sortable: true },
        { key: "CBO", label: "CBO", sortable: true },
        { key: "F", label: "Filial", sortable: true },
        { key: "GI", label: "GI", sortable: true },
        { key: "Salário", label: "Salário", sortable: true },
        { key: "EPI", label: "EPI", sortable: true },
        { key: "INATIVA", label: "Inativa", sortable: true },
      ],
      //////// defeitos da corretiva
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();

      // Define isLoadingFuncao como true para mostrar o indicador de carregamento
      this.isLoadingFuncao = true;

      reader.onloadstart = () => {
        this.progressValue = 0; // Inicia a barra de progresso
      };

      reader.onprogress = (e) => {
        if (e.lengthComputable) {
          // Atualiza a barra de progresso
          this.progressValue = (e.loaded / e.total) * 100;
        }
      };

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });

        // Supondo que os dados estejam na primeira aba
        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        // Converte a planilha em um array de objetos
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        // Armazena os dados no estado
        this.planilhaFuncao = jsonData;

        // Quando o processo for concluído, define isLoadingFuncao como false
        this.isLoadingFuncao = false;
      };

      reader.readAsBinaryString(file);
    },

    loadEmpresas() {
      let corpo = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.post(url, corpo).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    postFuncoes() {
      // Criação do corpo da requisição
      // NO JB UTILIZE O PROGRAMA VBP0113 - CADASTRO DE FUNCOES
      let corpo = {
        id_empresa:
          this.value_empresa.length > 0
            ? `${[this.value_empresa.map((e) => e.id_empresa)]}`
            : `${[this.user.id_empresa]}`,
        id_empresa_grupo: `${[this.user.id_grupo_empresa]}`,
        funcionario_id: `${this.user.id_funcionario}`,
        psg: `${this.user.psg}`,
        funcoes: [], // Aqui vamos armazenar o array de funções
      };

      // Preenchendo o array de funções
      this.planilhaFuncao.forEach((funcao) => {
        corpo.funcoes.push({
          funcao: funcao.FUNCAO, // O nome da função
          cbo: funcao.CBO, // O CBO
          f: funcao.F, // Algum outro campo
          gi: funcao.GI, // Algum outro campo
          salario: funcao["Salário"], // Salário
          epi: funcao.EPI, // EPI
          inativa: funcao.INATIVA, // Inatividade
        });
      });

      // URL do endpoint
      const url = `${baseApiUrl}/folha/importacao/funcao`;

      // Enviando a requisição POST com o array de funções
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess(); // Mensagem de sucesso
          // this.reset()  // Limpar os objetos e valores, se necessário
        })
        .catch(showError); // Em caso de erro
    },

    loadCarregaSac(planilhaFuncao) {
      this.funcao = { ...planilhaFuncao };
    },

    reset() {
      this.planilhaFuncao = "";
    },

    limparFiltro() {
      this.search = "";
    },
  },

  watch: {
    // Watcher que detecta alterações no valor de progressValue
    progressValue(newValue) {
      // Quando progressValue mudar, a barra de progresso será atualizada automaticamente
      //console.log(`Progresso: ${newValue}%`);
    },
  },

  mounted() {
    this.loadEmpresas();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.9em;
}

#re-nome {
  font-size: 0.9em;
}

#funcao {
  font-size: 0.9em;
}

#re-solicitante {
  font-size: 0.9em;
  font-style: inherit;
}

#parecer {
  font-size: 0.9em;
}

#rfilancamentos {
  font-size: 0.9em;
  text-align: center;
}

#resolicitante {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}
</style>